import React, { useEffect, useMemo, useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import logo from "../Assets/logo.webp";
import Button from "react-bootstrap/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import NavDropdown from "react-bootstrap/NavDropdown";
// import { ImBlog } from "react-icons/im";
import { FiChevronDown, FiGlobe } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { setLanguage } from "../i18n";

// import { CgFileDocument } from "react-icons/cg";
import './Navbar.css';

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const navigate = useNavigate(); // Create the navigate function
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const langCode = i18n.resolvedLanguage === "es" ? "ES" : "EN";
  const isSpanish = i18n.resolvedLanguage === "es";

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  useEffect(() => {
    scrollHandler();
    window.addEventListener("scroll", scrollHandler, { passive: true });
    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);

   // Function to handle button click for navigation
   const handleButtonClick = () => {
    navigate("/lab");
  };

  const active = useMemo(() => {
    const path = location.pathname;
    const isCommunityImpact = path.startsWith("/impact");
    const involvedPrefixes = [
      "/programs/ambassadors",
      "/programs/syep-internship",
      "/programs/community-tech-programs",
      "/programs/code-and-soil",
      "/programs/senior-citizens",
      "/programs/tech-pal",
      "/programs/partner-with-us",
      "/programs/volunteer-opportunities",
      "/programs/intern-experience",
      "/grants",
    ];
    const isInvolved = involvedPrefixes.some((prefix) => path.startsWith(prefix));

    return {
      home: path === "/",
      about: path.startsWith("/about") || path.startsWith("/careers"),
      communityImpact: isCommunityImpact,
      programs: path.startsWith("/programs") && !isInvolved,
      services: path.startsWith("/services"),
      team: path.startsWith("/team"),
      contact: path.startsWith("/contact"),
      involved: isInvolved || isCommunityImpact,
    };
  }, [location.pathname]);
  
  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="xxl"
      className={`cf-navbar${navColour ? " cf-navbar--scrolled" : ""}${isSpanish ? " cf-navbar--es" : ""}`}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="cf-navbar-brand d-flex" aria-label={t("nav.a11y.homeLink")}>
          <img
            src={logo}
            className="img-fluid logo"
            alt={t("nav.a11y.brandLogo")}
            width="120"
            height="120"
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />
        </Navbar.Brand>

        <div className="cf-navbar-right">
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            className="cf-navbar-toggle"
            onClick={() => {
              updateExpanded(expand ? false : "expanded");
            }}
          >
            <span></span>
            <span></span>
            <span></span>
          </Navbar.Toggle>
        </div>

        <Navbar.Collapse id="responsive-navbar-nav" className="cf-navbar-collapse">
          <Nav className="ms-auto cf-navbar-nav" aria-label="Primary">
            <Nav.Item>
              <Nav.Link as={Link} to="/" onClick={() => updateExpanded(false)} active={active.home}>
                {t("nav.home")}
              </Nav.Link>
            </Nav.Item>

            {/* About Dropdown */}
            <NavDropdown
              title={
                <span className="cf-dropdown-title">
                  {t("nav.about")} <FiChevronDown className="cf-dropdown-icon" aria-hidden="true" />
                </span>
              }
              id="about-nav-dropdown"
              menuVariant="light"
              active={active.about}
            >
              <NavDropdown.Item as={Link} to="/about/who-we-are" onClick={() => updateExpanded(false)}>
                {t("nav.whoWeAre")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/our-mission" onClick={() => updateExpanded(false)}>
                {t("nav.ourMission")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/our-story" onClick={() => updateExpanded(false)}>
                {t("nav.ourStory")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/our-partners" onClick={() => updateExpanded(false)}>
                {t("nav.ourPartners")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/careers" onClick={() => updateExpanded(false)}>
                {t("nav.careers")}
              </NavDropdown.Item>
            </NavDropdown>
            {/* End About Dropdown */}



            <NavDropdown
              title={
                <span className="cf-dropdown-title">
                  {t("nav.programs")} <FiChevronDown className="cf-dropdown-icon" aria-hidden="true" />
                </span>
              }
              id="programs-nav-dropdown"
              menuVariant="light"
              active={active.programs}
            >  
              <NavDropdown.Item as={Link} to="/courses" onClick={() => updateExpanded(false)}>
              {t("nav.careerTrainingPrograms")}
              </NavDropdown.Item>               
              <NavDropdown.Item as={Link} to="/programs/exploratory-learning" onClick={() => updateExpanded(false)}>
              {t("nav.workshopsExploratoryLearning")}
              </NavDropdown.Item>
           
            </NavDropdown>

            {/* Services Dropdown */}
            <NavDropdown
              title={
                <span className="cf-dropdown-title">
                  {t("nav.services")} <FiChevronDown className="cf-dropdown-icon" aria-hidden="true" />
                </span>
              }
              id="services-nav-dropdown"
              menuVariant="light"
              active={active.services}
            >
              <NavDropdown.Item as={Link} to="/projects#choicest" onClick={() => updateExpanded(false)}>
                {t("nav.projects")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/services/consulting-advisory" onClick={() => updateExpanded(false)}>
                {t("nav.consultingAdvisory")}
              </NavDropdown.Item>                                      
            </NavDropdown>
            {/* End Services Dropdown */}

              <NavDropdown
              title={
                <span className="cf-dropdown-title">
                  {t("nav.getInvolved")} <FiChevronDown className="cf-dropdown-icon" aria-hidden="true" />
                </span>
              }
              id="get-involved-nav-dropdown"
              menuVariant="light"
              active={active.involved}
            >
              <NavDropdown.Item as={Link} to="/programs/ambassadors" onClick={() => updateExpanded(false)}>
                {t("nav.ambassadors")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/programs/syep-internship" onClick={() => updateExpanded(false)}>
                {t("nav.internship")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/programs/community-tech-programs" onClick={() => updateExpanded(false)}>
                {t("nav.communityPrograms")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/programs/code-and-soil" onClick={() => updateExpanded(false)}>
                {t("nav.codeAndSoil")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/programs/senior-citizens" onClick={() => updateExpanded(false)}>
                {t("nav.seniorTech")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/programs/tech-pal" onClick={() => updateExpanded(false)}>
                {t("nav.techPal")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/programs/partner-with-us" onClick={() => updateExpanded(false)}>
                {t("nav.partnerWithUs")}
              </NavDropdown.Item>                   
              <NavDropdown.Item as={Link} to="/programs/volunteer-opportunities" onClick={() => updateExpanded(false)}>
                {t("nav.volunteerOpportunities")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/grants" onClick={() => updateExpanded(false)}>
                {t("nav.grantsRecognition")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/programs/intern-experience" onClick={() => updateExpanded(false)}>
                {t("nav.evidenceInAction")}
              </NavDropdown.Item>
            
            </NavDropdown>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/team"
                onClick={() => updateExpanded(false)}
                active={active.team}
              >
                {t("nav.team")}
              </Nav.Link>
            </Nav.Item>


            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/contact"
                onClick={() => updateExpanded(false)}
                active={active.contact}
              >
                 {t("nav.contact")}
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                href="https://choicestfruit.com/blog/"
                target="_blank"
                rel="noreferrer"
              >
                 {t("nav.blogs")}
              </Nav.Link>
            </Nav.Item>

            <Nav.Item className="cf-navbar-lab-tools">
              <div className="fork-btn cf-navbar-cta">
                <Button
                  onClick={() => {
                    updateExpanded(false);
                    handleButtonClick();
                  }}
                  className="fork-btn-inner"
                  type="button"
                >
                  {t("nav.cfLab")}
                </Button>
              </div>

              <div className="cf-navbar-utils-vertical" aria-label={t("nav.a11y.utilities")}>
                <div className="cf-lang-toggle">
                  <NavDropdown
                    title={
                      <span className="cf-dropdown-title" aria-label={t("common.language")} title={t("common.language")}>
                        <FiGlobe className="cf-dropdown-icon" aria-hidden="true" />
                        <span className="cf-lang-code">{langCode}</span>
                        <FiChevronDown className="cf-dropdown-icon" aria-hidden="true" />
                      </span>
                    }
                    id="language-nav-dropdown"
                    menuVariant="light"
                    align="end"
                  >
                    <NavDropdown.Item
                      onClick={() => {
                        setLanguage("en");
                        updateExpanded(false);
                      }}
                      active={i18n.resolvedLanguage === "en"}
                    >
                      {t("common.english")}
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      onClick={() => {
                        setLanguage("es");
                        updateExpanded(false);
                      }}
                      active={i18n.resolvedLanguage === "es"}
                    >
                      {t("common.spanish")}
                    </NavDropdown.Item>
                  </NavDropdown>
                </div>
              </div>
            </Nav.Item>

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
